import styled from "styled-components";

export const ButtonContainer = styled.div`
    width: 100%;
    margin: 20px auto;
`

export const InputWrapper = styled.div`
    margin-top: 30px;
    margin-bottom: 30px;
`

export const AmountText = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: 1rem auto;
   > p{
        color:  ${({ theme }) => theme.palette.common.text.secondary};
        font-size: 15px;
      
        margin: 0px;
        display: flex;
        width: 100%;
    }
`

export const Reward = styled.div`
    display: flex;
    flex-direction: column;

    p{
        color:  ${({ theme }) => theme.palette.common.text.secondary};
        font-size: 12px;
        margin: 0;
    }
    input[type='range'] {
        overflow: hidden;
   
      }
  
    input{


        color:${({ theme }) => theme.palette.card.text.primary};
    }
`

export const AmountDiv = styled.div`
justify-content: center;
display:flex;
p{
    color:  ${({ theme }) => theme.palette.common.text.secondary};
    font-size: 15px;
    margin: 0;
}
`
export const InputDiv = styled.div`
background: #fcfcfc 0% 0% no-repeat padding-box;
opacity: 1;
display:flex;
border: none;
padding: 12px;
width: 100%;
:focus-visible{

}

`

export const TextAlign = styled.div`
width: 100%;
color:  ${({ theme }) => theme.palette.common.text.secondary};
text-align: end;
display: block !important;
align-items: center;
height: 20px;
>p{
    color: ${(props) => props.theme.palette.common.text.secondary};
    font-size: 15px;
    width: 100%;
}
`

export const InputCurrency = styled.input`
border: none;
width: 100%;
font-size: 16px;
font-weight: 600;
outline: none !important;
background-color: pink !important;
`
export const Max = styled.button`
color: ${(props) => props.theme.palette.common.text.primary};
font-size: 16px;
display: contents;
font-weight: 600;
border: none;
margin: 0px;

width: 100%;


`

